import { render } from "./inheritance-worth.vue?vue&type=template&id=616a1f12&scoped=true"
import script from "./inheritance-worth.vue?vue&type=script&lang=js"
export * from "./inheritance-worth.vue?vue&type=script&lang=js"

import "./inheritance-worth.vue?vue&type=style&index=0&id=616a1f12&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616a1f12"]])

export default __exports__